<script>
import Store from '@/store/index.js'
import 'bulma/css/bulma.css'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth, signInWithRedirect, GoogleAuthProvider, TwitterAuthProvider } from 'firebase/auth'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData, signOutQnQ } from '@/api/FirebaseUserWrapper.js'
import { hasAdminRole } from '@/api/Utilities.js'
import PasswordLogin from './PasswordLogin'

const auth = getAuth(firebaseApp)
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')

const DOMAIN_NAME = 'qnqtree.com'

export default {
  components: {
    PasswordLogin
  },
  data () {
    return {
      userId: undefined,
      userData: undefined,
      isAnonymous: undefined,
      createdDone: false,
      isProdDmain: false,
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    if (location.hostname === DOMAIN_NAME || location.hostname === '2ndchat.com') { this.isProdDmain = true }
    this.userId = await getMyUserId()
    this.userData = await getMyUserData(this.userId)
    this.isAnonymous = this.userData.isAnonymous
    if (hasAdminRole) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'login/Login')
    }
    document.title = 'Login | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'Login | ' + this.title)
    this.createdDone = true
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  computed: {
    IsLoggingIn () {
      return Store.getters.getIsLoggingIn
    }
  },
  methods: {
    googleLogin: function () {
      Store.commit('setIsLoggingIn', true)
      Store.commit('setFromLogin', true)
      signInWithRedirect(auth, new GoogleAuthProvider())
    },
    twitterLogin: function () {
      Store.commit('setIsLoggingIn', true)
      Store.commit('setFromLogin', true)
      signInWithRedirect(auth, new TwitterAuthProvider())
    },
    async logout () {
      try {
        await signOutQnQ()
      } catch (error) {
        console.error(error)
      }
      location.reload(true)
    }
  }
}
</script>
<style scoped>
.login {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.password-login {
  margin: auto;
  max-width: 400px;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
</style>
<template>
  <div v-if="(!IsLoggingIn) && createdDone" class="login">
    <label class="label">登録・ログイン</label>
    <br/>

    <div id="login" v-if="isAnonymous">
      <!-- Google login -->
      <div id="gmail-login">
        <div class="button is-link is-outlined has-text-weight-bold" v-on:click="googleLogin">
          <span class="image is-24x24 has-text-left">
            <img class="is-rounded" src="./img/g-logo.png" alt="Placeholder image">
          </span>
          &nbsp;
          &nbsp;
          <span>GoogleでLogin</span>
        </div>
        <br>
        <br>
      </div>
      <!-- Twitter login -->
      <div id="twitter-login" v-if="!isProdDmain">
        <div class="button is-link is-outlined has-text-weight-bold" v-on:click="twitterLogin">
          <span class="image is-24x24 has-text-left">
            <img class="is-rounded" src="./img/t-logo.png" alt="Placeholder image">
          </span>
          &nbsp;
          &nbsp;
          <span>TwitterでLogin</span>
        </div>
        <br>
        <br>
      </div>
      <!-- SignUp & SignIN -->
      <hr>
      <PasswordLogin class="password-login"
      :isAnonymous = "isAnonymous"
      />
    </div>
    <!-- ログイン済み&&メール確認済み -->
    <div id="login" v-else-if="!isAnonymous && userData.emailVerified">
      <div class="button is-link is-outlined has-text-weight-bold" v-on:click="logout">
        <span>Logout</span>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <p class="text is-size-8">
      <router-link to="privacy">プライバシポリシー</router-link>に同意してログインする
    </p>
    <br>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/login/Login.vue